import { PaymentMethodEnum } from './enums/payment-method.enum';
import { ColorEnum } from './enums/color.enum';

export class PaymentMethod {
  public code!: PaymentMethodEnum;
  public translationKey!: string;
  public emoji!: string;
  public color!: ColorEnum;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_PAYMENT_METHOD: any = {
  CB: new PaymentMethod({ code: PaymentMethodEnum.CB, translationKey: 'LABEL.CB', emoji: '💳', color: ColorEnum.SUCCESS }),
  SEPA: new PaymentMethod({ code: PaymentMethodEnum.SEPA, translationKey: 'LABEL.SEPA', emoji: '⏩', color: ColorEnum.INFO }),
  OFFLINE: new PaymentMethod({ code: PaymentMethodEnum.OFFLINE, translationKey: 'LABEL.OFFLINE', emoji: '🚫', color: ColorEnum.WARNING }),
  INIT_TRANSFERT_IMMEDIATE: new PaymentMethod({
    code: PaymentMethodEnum.INIT_TRANSFERT_IMMEDIATE,
    translationKey: 'LABEL.INIT_TRANSFERT_IMMEDIATE',
    emoji: '🏳️‍⚧️',
    color: ColorEnum.SUCCESS,
  }),
  INIT_TRANSFERT_DEFERRED: new PaymentMethod({
    code: PaymentMethodEnum.INIT_TRANSFERT_DEFERRED,
    translationKey: 'LABEL.INIT_TRANSFERT_DEFERRED',
    emoji: '➡️',
    color: ColorEnum.INFO,
  }),
};
